import React from 'react';
import { SparklesIcon } from 'lucide-react';
const links = [{
  label: 'Términos y Condiciones',
  href: '#terminos'
}, {
  label: 'Política de Privacidad',
  href: '#privacidad'
}, {
  label: 'Contacto',
  href: '#contacto'
}];
export function Footer() {
  return <footer className="w-full bg-blue-900 py-14 text-white md:py-16" data-id="element-103" data-mp="32m1d94cmxar9">
      <div className="mx-auto w-full max-w-narrow px-5 text-center md:px-8" data-id="element-104" data-mp="36pz9966ny5g3">
        <p className="inline-flex items-center gap-2 font-display text-lg font-extrabold uppercase tracking-[0.14em] text-gold-300" data-id="element-105" data-mp="3ug3gromz2pcd">
          <SparklesIcon className="h-5 w-5" aria-hidden="true" data-id="element-106" data-mp="36muiocgf6ul" />
          BIO-RESET 5.0™
        </p>

        <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-7 gap-y-3 text-blue-100" data-id="element-107" data-mp="3lggd0w6rt7g5">
          {links.map(link => <li key={link.label} data-id="element-108" data-mp="29yno3sf6hjhp">
              <a href={link.href} className="transition-colors duration-150 ease-calm hover:text-gold-300" data-id="element-109" data-mp="29ydrvn3jig3k">
                {link.label}
              </a>
            </li>)}
        </ul>

        <p className="mt-10 border-t border-blue-800 pt-6 text-sm text-blue-200" data-id="element-110" data-mp="3gagzxq623d49">
          © BIO-RESET 5.0™ 2026. Todos los derechos reservados.
        </p>
        <p className="mt-2 text-sm text-blue-200/80" data-id="element-111" data-mp="3v9b1tiy2kafh">
          El contenido de este sitio no reemplaza consulta médica profesional.
        </p>
      </div>
    </footer>;
}